module.exports = __webpack_public_path__ + "static/tlapky_gray-f7fc4c356234a032f48d9244f68ba99d.png";